import React from "react";

const SearchIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.753 13.5752L11.4589 10.2798C12.4466 8.99271 12.9077 7.37816 12.7488 5.76362C12.5898 4.14908 11.8226 2.65547 10.6029 1.58576C9.38317 0.516053 7.80222 -0.0496446 6.18074 0.0034225C4.55927 0.0564897 3.01869 0.724348 1.87152 1.87152C0.724348 3.01869 0.0564897 4.55927 0.0034225 6.18074C-0.0496446 7.80222 0.516053 9.38317 1.58576 10.6029C2.65547 11.8226 4.14908 12.5898 5.76362 12.7488C7.37816 12.9077 8.99271 12.4466 10.2798 11.4589L13.5766 14.7565C13.654 14.8339 13.746 14.8953 13.8471 14.9372C13.9483 14.9791 14.0567 15.0007 14.1662 15.0007C14.2757 15.0007 14.3841 14.9791 14.4853 14.9372C14.5864 14.8953 14.6784 14.8339 14.7558 14.7565C14.8332 14.6791 14.8946 14.5871 14.9365 14.486C14.9784 14.3848 15 14.2764 15 14.1669C15 14.0574 14.9784 13.949 14.9365 13.8478C14.8946 13.7466 14.8332 13.6547 14.7558 13.5773L14.753 13.5752ZM1.67871 6.39542C1.67871 5.46255 1.95534 4.55062 2.47362 3.77496C2.9919 2.9993 3.72855 2.39475 4.59042 2.03775C5.45228 1.68076 6.40065 1.58735 7.31561 1.76934C8.23056 1.95134 9.07099 2.40056 9.73064 3.06021C10.3903 3.71985 10.8395 4.56029 11.0215 5.47524C11.2035 6.39019 11.1101 7.33856 10.7531 8.20043C10.3961 9.06229 9.79154 9.79894 9.01588 10.3172C8.24022 10.8355 7.3283 11.1121 6.39542 11.1121C5.14487 11.1108 3.9459 10.6135 3.06163 9.72922C2.17735 8.84494 1.68 7.64598 1.67871 6.39542Z"
        fill="#666666"
      />
    </svg>
  );
};

export default SearchIcon;
